import { I18n as InitI18n } from 'i18n-js';
import translations from './../translations.json';

export const I18n = new InitI18n(translations);
I18n.defaultLocale = 'fi';
window.I18n = I18n;

export function setLocale () {
  let currentLang = $('html').attr('lang');
  if (I18n) {
    I18n.locale = currentLang;
  }
}